import React, { Component } from "react";
import {
  DataGrid,
  GridColumn,
  LinkButton,
  ButtonGroup,
  Panel,
  ComboBox,
  TextBox,
  Messager,
  Dialog
} from "rc-easyui";
import Dimage from '../../../assets/D.png';
import Simage from '../../../assets/S.png';
import { logout } from '../../../helpers/index';
import { Button } from "reactstrap";

import { Link } from "react-router-dom";
import setTitle from "../../../helpers/TitleComponent";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { getFormattedDate, isEmpty, isEmptyString } from "../../../helpers";

const axios = require("axios");

export default class ClientList extends Component {
  constructor(props) {
    super(props);
    this.refereshData = this.refereshData.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      permissions: [],
      data: [],
      allMarketingAgentList: [],
      pageOptions: {},
      search: { clientname: "", status: true, mrid: "" },
      restPassword: '',
      isLoading: false,
      selected: {},

    };
  }

  getMarketinRepresentativeForComboBox = async () => {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/getmarketingagentforcombo/`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              allMarketingAgentList: response.data.object,
            });
          }
        })
        .catch(function (error) { });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  };
  componentDidMount() {
    this.dlg.close();
    let data = getCookie("permission")


    this.setState(
      {
        pageOptions: {
          pageOptions: {
            pageNumber: 1,
            pageSize: 20,
            pageList: [20, 50, 100, 200],
            layout: [
              "list",
              "sep",
              "first",
              "prev",
              "next",
              "last",
              "sep",
              "refresh",
              "sep",
              "manual",
              "info",
            ],
          },
        },
        permissions: data,
      },
      () => {
        setTitle("Client List");
        this.refereshData();
        this.getMarketinRepresentativeForComboBox();
      }
    );
  }

  async refereshData() {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    const { clientname, status, mrid } = this.state.search;

    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    var url =
      API_URL +
      "api/getallclientsregistrationinfo?rows=" +
      pageSize +
      "&page=" +
      pageNumber +
      "&clientname=" +
      clientname +
      "&mrid=" +
      mrid +
      "&status=" +
      status;

    this.setState({
      pageOptions: {
        pageOptions: {
          ...this.state.pageOptions.pageOptions,
        },
        loading: true,
      },
    });
    if (access_token != null) {
      axios
        .get(url, axiosConfig)
        .then((response) => {
          if (response.status === 200) {
            var data = response.data.rows;
            var total = response.data.total;

            this.setState({
              data: data,
              pageOptions: {
                pageOptions: {
                  pageSize: 20,

                  pageList: [20, 50, 30, 100, total].sort(function (a, b) {
                    return a - b;
                  }),
                  total: total,
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {

          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      //Access Token Expired.
      //Generate new Access Token using Refresh Token.
      const resp = await getAccessToken();
      if (resp) {
        this.refereshData();
      }
    }
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.search);
    if (value === false) {
      user[name] = value;
    } else {
      user[name] = isEmptyString(value) ? "" : value;
    }
    this.setState({ search: user });
  }

  onPageChange(event) {
    delete event["refresh"];
    delete event["filterRules"];

    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
        },
      },
      function () {

        this.refereshData();
      }
    );
  }
  onChangeRestHandler = (name, value) => {
    const newRestData = { ...this.state.resetData };
    newRestData[name] = value;
    this.setState({ resetData: newRestData });
  }
  onRestPassword = (row) => {


    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");

    let apiUrl = `${API_URL}api/resetpassword`;

    let headersConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    const { systemusername, clientid } = row
    const resetInfo = { username: systemusername, clientid };


    if (access_token != null) {
      this.messager.confirm({
        title: "Confirm",
        msg: "Are you sure want to reset password?",
        result: r => {
          if (r) {
            this.setState({ isLoading: true })
            axios
              .post(apiUrl, resetInfo, headersConfig)
              .then((response) => {

                if (response.status === 200 && !isEmpty(response.data)) {
                  this.setState({ isLoading: false, restPassword: response.data.object }, () => this.dlg.open())
                }
              })
              .catch((error) => {


                var response = error['response']
                if (response !== undefined) {
                  if (response.data.status === 403) {
                    this.setState({ isLoading: false })
                    this.messager.alert({
                      title: 'Error',
                      icon: 'error',

                      msg: response.data.message,
                    }) // Backend Validation Error ie.403

                  } else {
                    this.setState({ isLoading: false })

                    this.messager.alert({
                      title: 'Error',
                      msg: 'UnCaught Error',
                      icon: 'error',

                    })
                    // Uncaught Backend Error ie.500 eyc.
                  }
                } else {
                  this.setState({ isLoading: false })
                  this.messager.alert({
                    title: 'Error',
                    icon: 'error',
                    msg: 'Internal Server Error',

                  })
                  // Caused due to syntax error in front end
                }
              });
          }
          else {
            return;
          }
        }

      });

    }
  }
  onSelectionChange = (selected) => {
    this.setState({
      selected: selected,
    });
  }
  getRowCss = (row) => {
    // console.log(row);
    // if (row.enabled === false) {
    //   return { background: "#8b0000" };
    // }
    let date = Date.now();
    // console.log(date);
    if (row.expirydate < date) {
      return { background: "#FF7F7F" };
    }
  }


  render() {
    const { search, allMarketingAgentList } = this.state;

    return (
      <div>
        <div className="container-fluid" style={{ marginTop: "10px" }}>
          <div className={this.state.isLoading ? "loadingmodel" : ""}></div>
          <div className="row">
            <div className="col-12">
              <Dialog
                title="Reset Password"
                style={{ width: '600px', height: '250px' }}
                className="Notification_Middle"
                modal
                ref={ref => this.dlg = ref}
                onClose={this.onCloseDialog}
              >
                <div className="f-full" style={{ margin: "30px 10px 20px 5px" }}>

                  <p style={{ fontSize: "1.2rem", color: "#ff0000" }}>{`Confidential ! do not share it with unauthorized person. Inform the user to change password immediately after login.`}</p>
                  <p style={{ fontSize: "1.2rem", color: "#ff0000" }}>New password for the user is <span style={{ fontSize: "0.8rem", color: "#000000" }}>{this.state.restPassword}</span> </p>


                </div>
              </Dialog>
              <Messager className={"Notification_Middle"} ref={ref => this.messager = ref}></Messager>
              <Panel
                title="Client List"
                bodyStyle={{ padding: 0 }}
                style={{ height: 590 }}
              >
                <div id="toolbar" className="datagrid-toolbar">
                  <b>Client Name</b>&nbsp;
                  <input
                    type="text"
                    placeholder="Client Name"
                    className="custom_input"
                    onChange={(e) =>
                      this.handleChange(e.target.name, e.target.value)
                    }
                    style={{ height: 30 }}
                    name="clientname"
                    id=""
                  />{" "}
                  &nbsp;&nbsp;
                  <b>Marketing Agent</b>&nbsp;
                  <ComboBox
                    data={allMarketingAgentList}
                    editable={true}
                    value={search.mrid}
                    onChange={(e) => this.handleChange("mrid", e)}
                    textField="name"
                    valueField="id"
                    style={{ width: 300 }}
                  ></ComboBox>
                  &nbsp;&nbsp;
                  <b>Status</b>&nbsp;
                  <ComboBox
                    data={[
                      { value: true, text: "Active" },
                      { value: false, text: "Inactive" },
                    ]}
                    // editable={false}
                    onChange={(e) => this.handleChange("status", e)}
                    value={search.status}
                    style={{ width: "100" }}
                  ></ComboBox>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    type="button"
                    color="primary"
                    data-testid="loginbtn"
                    size="sm"
                    onClick={this.refereshData}
                  >
                    Search
                  </Button>
                </div>

                <DataGrid
                  data={this.state.data}
                  rowCss={this.getRowCss}
                  {...this.state.pageOptions}
                  pagination
                  style={{ height: 520 }}
                  selectionMode='single'
                  {...this.state.selected}
                  onSelectionChange={(selected) =>
                    this.onSelectionChange(selected)
                  }
                onPageChange={this.onPageChange}
                // pagination
                >
                  <GridColumn
                    field="rn"
                    align="center"
                    width="30px"
                    cellCss="datagrid-td-rownumber"
                    render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
                  />
                  {/* <GridColumn field='itemid' title='Sr_no.'></GridColumn> */}
                  <GridColumn
                    field="organizationname"
                    title="Client Name"
                    width={200}
                  ></GridColumn>
                  <GridColumn
                    field="systemusername"
                    title="Username"
                    width={120}

                  >
                  </GridColumn>
                  <GridColumn
                    width={120}
                    field="provience"
                    title="Provience"
                  ></GridColumn>
                  <GridColumn
                    width={140}
                    field="phoneno"
                    title="Phone No."
                  ></GridColumn>
                  <GridColumn
                    width={160}
                    field="contactpersonname"
                    title="Contact Person Name"
                  ></GridColumn>
                  <GridColumn
                    width={160}
                    field="mr"
                    title="Marketing Agent"
                  ></GridColumn>
                  <GridColumn
                    width={160}
                    field="planname"
                    title="Price Plan"
                  ></GridColumn>
                  <GridColumn
                    width={140}
                    field="panvatnumber"
                    title="PAN/VAT Number"
                  ></GridColumn>
                  <GridColumn
                    width={160}
                    field="installationcharge"
                    title="Installation Charge"
                  ></GridColumn>
                  <GridColumn
                    field="renewcharge"
                    title="Renewal Charge"
                    width={140}
                  ></GridColumn>
                  <GridColumn
                    width={110}
                    field="expirydate"
                    title="Expiry Date"
                    render={({ row }) => (
                      <span>{getFormattedDate(row.expirydate)}</span>
                    )}
                    sortable
                  ></GridColumn>
                  <GridColumn
                    width={110}
                    field="enabled"
                    title="Status"
                    render={({ row }) => (
                      <span>{row.enabled ? "Active" : "Inactive"}</span>
                    )}
                    sortable
                  ></GridColumn>

                  <GridColumn
                    field="act"
                    title="Actions"
                    align="center"
                    width={170}
                    render={({ row }) => (
                      <div>



                        {this.state.permissions.includes('reset-password') ? (
                          <React.Fragment>

                            <LinkButton

                              plain
                              reprint

                              onClick={(e) => this.onRestPassword(row)}
                            >


                              <svg
                                xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bootstrap-reboot" viewBox="0 0 16 16">
                                <path d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 1 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8z" />
                                <title>Reset Password</title>
                                <path d="M6.641 11.671V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141zm0-3.75V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6z" />
                              </svg>
                            </LinkButton>
                            <span style={{ paddingTop: 5 }}>||</span>
                          </React.Fragment>
                        ) : null}

                        {this.state.permissions.includes('technical-access-create') ? (
                          <React.Fragment>

                            <Link target="_blank" style={{ paddingTop: 6, margin: "0 5px" }} to={`/runfreshdata?clientId=${row.clientid}`}>

                              <img style={{ width: "18px" }}
                                title="Data"
                                src={Dimage}
                                alt="runfreshdata" />
                            </Link>
                            <span style={{ paddingTop: 5 }}>||</span>
                            <Link target="_blank" style={{ paddingTop: 6, margin: "0 5px" }} to={`/runfreshscript?clientId=${row.clientid}`}>
                              <img style={{ width: "18px", }}
                                title="Script"
                                src={Simage}
                                alt="runfreshscript" />
                            </Link>
                          </React.Fragment>)
                          : null}
                        {this.state.permissions.includes(
                          "client-registration-edit"
                        ) ? (

                          <React.Fragment>
                            <span style={{ paddingTop: 5 }}>||</span>
                            <Link className="btn btn-link btn-sm" to={"/update-client/" + row.clientid}>

                              View
                            </Link>
                          </React.Fragment>) : null}



                      </div>
                    )}
                  />
                </DataGrid>
              </Panel>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
